<template>

  <popup
    buttonStyle="primary"
    heading="Agreement"
    :showText="showText"
    size="default"
    button-size="mini"
    buttonText="Agreement"
    buttonIcon="fa fa-asterisk"
    :disableButton="!isManager('finance|admin|management')"
    @save="onSaveDialog"
    @close="onCloseDialog">

    <div style="text-align: left;">
      <agreement-details adding :row-data="rowData" />
    </div>

  </popup>

</template>

<script>

import AgreementDetails from '@/components/finance/rates/AgreementDetails'

export default {
  name: 'AgreementAction',

  components: {
    AgreementDetails
  },

  props: {
    siteId: {
      type: Number,
      default: null
    },
    showText: {
      type: Boolean,
      default: true
    },
  },

  methods: {
    onSaveDialog () {
      this.$refs.inv.onSave()
    },
    onCloseDialog () {
      this.$refs.inv.onClose()
    }
  },

  data () {
    return {
      rowData: {},
    }
  }
}

</script>



// WEBPACK FOOTER //
// AgreementAction.vue?ddf8f782